module.exports = __webpack_public_path__ + "static/media/teaching_icon_3.9d79ec69.svg";